import type { ForwardRefExoticComponent, RefAttributes } from 'react';
import React from 'react';
import type { IconProps, Icon } from '@tabler/icons-react';
import {
	IconBooks,
	IconCalendar,
	IconFile,
	IconFileChart,
	IconMicrophone,
	IconPresentationAnalytics,
	IconCertificate,
	IconStethoscope,
	IconTools,
	IconVideo,
	IconNews,
	IconBriefcase,
} from '@tabler/icons-react';

export type ResourceTypeIconProps = {
	className?: string;
	name: string;
	size?: string | number;
	stroke?: string | number;
};

export default function ResourceTypeIcon(props: ResourceTypeIconProps) {
	const { className, name, size, stroke } = props;

	const sizeStr = size ? (typeof size === 'number' ? `${size}px` : size) : '1.5em';

	const IconComponent = iconMap[name] ?? IconFile;

	return (
		<span className={`ResourceTypeIcon ${className ?? ''}`}>
			<IconComponent style={{ width: sizeStr, height: sizeStr }} size={sizeStr} stroke={stroke} />
		</span>
	);
}

const iconMap: Record<string, ForwardRefExoticComponent<IconProps & RefAttributes<Icon>>> = {
	Article: IconNews,
	Event: IconCalendar,
	Quiz: IconCertificate,
	Resource: IconBriefcase,
	'Clinical demonstration': IconStethoscope,
	'Clinical tools and guidelines': IconTools,
	'Education article': IconBooks,
	'NDC research publication': IconFileChart,
	'Parent handout': IconFile,
	Podcast: IconMicrophone,
	Slides: IconPresentationAnalytics,
	Video: IconVideo,
};
